export const loyaltyBonusEndpoint =
  '/bonus-ms/v1/bonus/loyalty/segmentation-user';
